import { MouseEvent, useContext } from 'react';
import { Context } from '@components/Context';
import { BoxState, NavigateToProductParams } from '@contracts';
import { productClickTrack } from '@utils/tracking';
import { getIsPresetTamponBox, getTrackingId } from './product';
import useNavigate from './useNavigate';

export const useNavigateToProduct = ({ data, disableClickEvents, boxConfig, link, callback }: NavigateToProductParams) => {
  const { dispatch } = useContext(Context);
  const isPresetTamponBox = getIsPresetTamponBox(data.product_code_override?.text);
  const trackingId = getTrackingId(data);
  const { navigateWrapper } = useNavigate();

  return {
    navigateToProduct: (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      if (disableClickEvents) {
        return;
      }

      productClickTrack(trackingId);

      if (isPresetTamponBox && boxConfig) {
        const sum = Object.values(boxConfig).reduce((a, b) => a + b, 0);
        const selectedBox: BoxState = { ...boxConfig, boxSize: sum };
        dispatch({ type: 'setSelectedBox', data: selectedBox });
      }

      navigateWrapper(link);

      callback?.();
    }
  };
};
